import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'
import {Root as RadioGroupRoot, Item as RadioGroupItem} from '@radix-ui/react-toggle-group'

export const StyledConfirmationDialogAccordionButton = styled(Button)(
    ({theme: {palette}}) => css`
        justify-content: space-between;
        font-weight: 400;
        color: ${palette.neutral[950]};

        & b {
            font-weight: 500;
        }
    `
)

export const StyledConfirmationDialogAccordionContainer = styled(Flexbox)`
    flex-wrap: wrap;
`

export const StyledConfirmationDialogRadioGroup = styled(RadioGroupRoot)(
    () => css`
        width: 100%;

        & button:first-child {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
        }

        & button:last-child {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    `
)

export const StyledConfirmationDialogRadioItem = styled(RadioGroupItem)<{
    $isSelected: boolean
}>(
    ({theme: {palette, spacing, transition, typography}, $isSelected}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: ${spacing}px;
        outline: 1px solid ${$isSelected ? palette.primary[300] : palette.neutral[300]};
        background-color: ${$isSelected ? palette.primary[50] : palette.neutral.white};
        color: ${$isSelected ? palette.primary[600] : palette.neutral[900]};
        cursor: pointer;
        transition: ${transition};
        font-size: ${typography.textSm};
    `
)

export const StyledConfirmationDialogConversation = styled(Flexbox)(
    ({theme: {palette}}) => css`
        width: 100%;
        border: 1px solid ${palette.neutral[300]};
        border-radius: 8px;
    `
)
